import { createSlice } from "@reduxjs/toolkit";
import { changeMotherBoard } from "../../thunks/changeMotherBoardThunks";

/**
 * When user confirms mother board change, SW Serial Id (deviceId) is shown
 * as empty until the read model reports a new id (we compare to deviceId before the change).
 */
export type DeviceIdOverrideState = {
  bySerialId: Record<
    string,
    { forceEmpty: true; deviceIdBeforeChange: string }
  >;
};

export const initialDeviceIdOverrideState: DeviceIdOverrideState = {
  bySerialId: {},
};

const deviceIdOverrideSlice = createSlice({
  name: "deviceIdOverride",
  initialState: initialDeviceIdOverrideState,
  reducers: {
    clearDeviceIdOverride: (
      state,
      action: { payload: string /* hub serial in route */ },
    ) => {
      const id = action.payload;
      if (id in state.bySerialId) {
        delete state.bySerialId[id];
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(changeMotherBoard.fulfilled, (state, action) => {
      const { serialNumber, deviceIdBeforeChange } = action.meta.arg;
      state.bySerialId[serialNumber] = {
        forceEmpty: true,
        deviceIdBeforeChange,
      };
    });
  },
});

export const { clearDeviceIdOverride } = deviceIdOverrideSlice.actions;
export default deviceIdOverrideSlice.reducer;
